import HomePage from "./pages/HomePage";
import AtelierPage from "./pages/AtelierPage";
import ContactPage from "./pages/ContactPage";
import { useLayoutEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { PortfolioThemeProvider } from "./contexts/PortfolioTheme";
import "./styles/App.scss";

const PortfolioRoutes = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView?.();
    } else {
      (document.scrollingElement || document.documentElement).scrollTop = 0;
    }
  }, [pathname, hash]);

  return (
    <Routes>
      <Route path="/atelier" element={<AtelierPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
};

function App() {
  return (
    <PortfolioThemeProvider>
      <BrowserRouter>
        <PortfolioRoutes />
      </BrowserRouter>
    </PortfolioThemeProvider>
  );
}

export default App;
